
import { IAnalyticsServiceConfiguration } from '..'
import { IAnalyticsTagManager } from '../../../domain/analytics/analytics-configuration'
import { FullContact } from '../adapters/fullcontact'
import { Optable } from '../adapters/optable'
import { ComScore } from './comscore'
import { GTM } from './gtm'
import { LiveRamp } from './live-ramp'
import { Permutive } from './permutive'

export interface ITagManager {
    init(tags: IAnalyticsTagManager, conf?: object): any
    initializePermutive(tags: IAnalyticsTagManager,config?: IAnalyticsServiceConfiguration): void
    initializeLiveRamp(tags: IAnalyticsTagManager): void
}

export class TagManager implements ITagManager {
    /**
     * Initialize Google Tag Manager
     */
    private permutive: Permutive
    private liveRamp: LiveRamp
    public init(tags: IAnalyticsTagManager): void {
        if (tags.gtm && tags.gtm.length > 0) {
            const gtm = new GTM()
            tags.gtm.forEach((account: string) => {
                gtm.init(account)
            })
        }

        if (tags.comScore) {
            const comscore = new ComScore()
            comscore.init(tags.comScore)
        }

        if (tags.gtm_params && tags.gtm_params.html && tags.gtm_params.html.container_id) {
            const gtm = new GTM('gtm_data_layer')
            const gtmHtml = tags.gtm_params.html
            gtm.init(gtmHtml.container_id, gtmHtml.auth, gtmHtml.env)
        }
        if(tags.fullContact) {
            const fullContact = new FullContact()
            fullContact.initialize(tags.fullContact)
        }
        if (tags.optable && tags.optable.enabled) {
            const optable = new Optable()
            optable.initialize(tags.optable.slug)
        }
        this.initializePermutive(tags)
        this.initializeLiveRamp(tags)
    }
    public initializePermutive(tags: IAnalyticsTagManager, config?: IAnalyticsServiceConfiguration): void {
        /**
         * Initialize permutive so we can load it before ads
         */
        if (typeof this.permutive === 'undefined' && tags.permutive && tags.permutive.organization_id) {
            this.permutive = new Permutive()
            const permutiveKeys = tags.permutive
            this.permutive.init(permutiveKeys.organization_id, permutiveKeys.workspace_id,
                permutiveKeys.workspace_api_key)
            this.permutive.sendPageViewEvent(config)
        }
    }
    public initializeLiveRamp(tags: IAnalyticsTagManager): void {
        /**
         * Initialize liveRamp so we can load as soon as possible
         */
        if (typeof this.liveRamp === 'undefined' && tags.live_ramp) {
            this.liveRamp = new LiveRamp()
            this.liveRamp.init(tags.live_ramp)
        }
    }
}
